export interface PixResponse {
  tabela: Array<{
    totalPrestacao: number;
    prestacao: number;
    parcela: number;
    juros: number;
    amortizacao: number;
    saldo: number;
    valorFinalParcela: number;
  }>;
  totalTaxaMensal: number;
  totais: {
    totalPrestacao: number;
    totalJuros: number;
    totalAmortizacao: number;
  };
  selectValorParcela: boolean;
}

export interface PixParceladoResult {
  tabela: Array<{
    totalPrestacao: number;
    prestacao: number;
    parcela: number;
    juros: number;
    amortizacao: number;
    saldo: number;
    valorFinalParcela: number;
  }>;
  totalTaxaMensal: number;
  totais: {
    totalPrestacao: number;
    totalJuros: number;
    totalAmortizacao: number;
  };
  selectValorParcela: boolean;
}
interface variaveisCalculo {
  valorPix: number;
  numeroParcela: number;
  valorParcela: number;
  i: number;
  tabela: Array<{
    totalPrestacao: number;
    prestacao: number;
    parcela: number;
    juros: number;
    amortizacao: number;
    saldo: number;
  }>;
}
interface variaveisCampo {
  valorPix: string;
  numeroParcela: string;
  valorParcela: string;
  taxaMensal: string;
}

function gerarTabela({
  valorPix,
  valorParcela,
  numeroParcela,
  i,
}: variaveisCalculo) {
  let saldo = valorPix;
  const tabela = [];
  tabela.push({
    totalPrestacao: 0,
    parcela: 0,
    prestacao: 0,
    juros: 0,
    amortizacao: 0,
    saldo: valorPix,
    valorFinalParcela: 0,
  });
  for (let k = 1; k <= numeroParcela; k++) {
    const valorFinalParcela =
      Math.round((valorPix / numeroParcela) * (1 + i) ** k * 100) / 100;
    const juros = Math.round(saldo * i * 100) / 100;
    const amortizacao = Math.round((valorParcela - juros) * 100) / 100;
    saldo = saldo - amortizacao;

    tabela.push({
      totalPrestacao: valorParcela,
      juros,
      parcela: k,
      prestacao: valorParcela,
      amortizacao,
      saldo: saldo < 0.0000001 ? 0 : saldo,
      valorFinalParcela: valorFinalParcela,
    });
  }

  return tabela;
}
function calcularTotais({ tabela }: variaveisCalculo) {
  let totalPrestacao = 0;
  let totalJuros = 0;
  let totalAmortizacao = 0;

  for (const linha of tabela) {
    totalPrestacao += linha.prestacao;
    totalJuros += linha.juros;
    totalAmortizacao += linha.amortizacao;
  }

  return {
    totalPrestacao,
    totalJuros,
    totalAmortizacao,
  };
}

export function calcularParcelamento({
  valorPix,
  numeroParcela,
  valorParcela,
  taxaMensal,
}: variaveisCampo) {
  const _valorPix = Number(valorPix);
  const _valorParcela = Number(valorParcela);
  const _numeroParcela = Number(numeroParcela);
  const _taxaMensal = Number(taxaMensal) / 100;
  const tabela = gerarTabela({
    valorPix: _valorPix,
    numeroParcela: _numeroParcela,
    valorParcela: _valorParcela,
    i: _taxaMensal,
    tabela: [],
  });
  const totais = calcularTotais({
    valorPix: _valorPix,
    numeroParcela: _numeroParcela,
    valorParcela: _valorParcela,
    i: _taxaMensal,
    tabela: tabela,
  });

  return { _taxaMensal, tabela, totais };
}
